function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Flag Red");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "path-1",
  x: 0,
  y: 0,
  width: 356,
  height: 131,
  rx: 3
}), /*#__PURE__*/React.createElement("filter", {
  x: "-8.4%",
  y: "-22.9%",
  width: "116.9%",
  height: "145.8%",
  filterUnits: "objectBoundingBox",
  id: "filter-2"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0",
  type: "matrix",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  in: "SourceAlpha",
  result: "shadowOffsetOuter2"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.5,
  in: "shadowOffsetOuter2",
  result: "shadowBlurOuter2"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0",
  type: "matrix",
  in: "shadowBlurOuter2",
  result: "shadowMatrixOuter2"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter2"
}))));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Web-&-App",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Home-List",
  transform: "translate(-358.000000, -2963.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4-Copy-3",
  transform: "translate(30.000000, 2949.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Flag-Red",
  transform: "translate(328.500000, 15.130836)",
  stroke: "#B6223E"
}, /*#__PURE__*/React.createElement("line", {
  x1: 0.5,
  y1: 0.869164259,
  x2: 0.5,
  y2: 10.8691643,
  id: "Line-3",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.5,0.869164259 C1.05517163,0.1662523 1.8660608,-0.110314566 2.93266749,0.0394636599 C4.53257753,0.264130999 4.85936148,1.47119285 6.03709822,1.64671118 C6.82225604,1.7637234 7.6432233,1.50454109 8.5,0.869164259 L8.5,5.86916426 C7.99298439,6.49463636 7.20464782,6.73263324 6.13499031,6.5831549 C4.53050403,6.35893738 4.223126,5.25569119 3.01084401,5.10208702 C2.20265601,4.99968424 1.36570801,5.25537666 0.5,5.86916426 L0.5,0.869164259 Z",
  id: "Rectangle",
  strokeLinejoin: "round"
})))));

var SvgFlagRed = function SvgFlagRed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "13px",
    viewBox: "0 0 10 13",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFlagRed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/flag_red.7a7d5bf7.svg";
export { ForwardRef as ReactComponent };